import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import About from "./about";
import Posts from "./blog/posts";
import Logs from "./logs";
import RepositoriesList from "./repositories-list";
import TechStack from "./tech-stack";
import Achievements from "./achievements";

// import EducationStory from "./education-story";
import MyStory from "./my-story";

const routes = [
	{ path: "/about", exact: true, name: "About", component: About },
	{ path: "/blog", exact: true, name: "Blog", component: Posts },
	{ path: "/logs", exact: true, name: "Logs", component: Logs },
	{
		path: "/achievements",
		exact: true,
		name: "Achievements",
		component: Achievements,
	},

	{
		path: "/open-source",
		exact: true,
		name: "OpenSource",
		component: RepositoriesList,
	},

	{ path: "/tech-stack", exact: true, name: "Tools", component: TechStack },
	{
		path: "/story-timeline",
		exact: true,
		name: "My Story",
		component: MyStory,
	},
];
const Navigation = () => {
	return (
		<Switch>
			<Route exact path="/">
				<Redirect to="/blog" />
			</Route>
			<Route exact path="/archive">
				<Redirect to="/blog" />
			</Route>
			<Route exact path={["/blog/notebook-app", "/blog/notebook-app-23"]}>
				<Redirect to="/logs" />
			</Route>
			{routes.map((route, idx) => (
				<Route
					key={idx}
					exact={route.exact}
					path={route.path}
					component={route.component}
				/>
			))}
			<Redirect to="/blog" />
		</Switch>
	);
};

export default Navigation;
